import React from 'react';
import { pathConcat } from '../utils/rPath';
import { useFieldContext } from '../Other';
/** 根据fieldcontext 和传入的name，计算出完整的name */

export const useContentName = ({
  name: nameIn
}) => {
  const {
    preName
  } = useFieldContext();
  const name = React.useMemo(() => {
    return pathConcat(preName, nameIn !== null && nameIn !== void 0 ? nameIn : '');
  }, [nameIn, preName]);
  return {
    name
  };
};
//# sourceMappingURL=es/hooks/useContentName.js.map